const countryOverview = [
    {
      "city": "New York City",
      "latitude": 40.6974034,
      "longitude": -74.1197631,
      "country": "USA",
      "HNWIGrowth": 40,
      "millionaires": 340000,
      "centiMillionaires": 724,
      "billionaires": 58,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Tokyo",
      "latitude": 35.5079446,
      "longitude": 139.2093978,
      "country": "Japan",
      "HNWIGrowth": -5,
      "millionaires": 290300,
      "centiMillionaires": 250,
      "billionaires": 14,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "The Bay Area",
      "latitude": 37.8773097,
      "longitude": -122.9807473,
      "country": "USA",
      "HNWIGrowth": 68,
      "millionaires": 285000,
      "centiMillionaires": 629,
      "billionaires": 63,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "London",
      "latitude": 51.5285582,
      "longitude": -0.2416795,
      "country": "UK",
      "HNWIGrowth": -15,
      "millionaires": 258000,
      "centiMillionaires": 384,
      "billionaires": 36,
      "region": "Europe",
      "linkText": "Apply for residence by investment in the UK here",
      "link": "https://www.henleyglobal.com/residence-investment/united-kingdom",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Singapore",
      "latitude": 1.3139961,
      "longitude": 103.7041657,
      "country": "Singapore",
      "HNWIGrowth": 40,
      "millionaires": 240100,
      "centiMillionaires": 329,
      "billionaires": 27,
      "region": "Asia Pacific",
      "linkText": "Apply for residence by investment in Singapore here",
      "link": "https://www.henleyglobal.com/residence-investment/singapore",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Los Angeles",
      "latitude": 34.0201613,
      "longitude": -118.6919124,
      "country": "USA",
      "HNWIGrowth": 35,
      "millionaires": 205400,
      "centiMillionaires": 480,
      "billionaires": 42,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Hong Kong",
      "latitude": 22.3526632,
      "longitude": 113.9876163,
      "country": "Hong Kong (SAR China)",
      "HNWIGrowth": -27,
      "millionaires": 129500,
      "centiMillionaires": 290,
      "billionaires": 32,
      "region": "Asia Pacific",
      "linkText": "Apply for residence by investment in Hong Kong (SAR China) here",
      "link": "https://www.henleyglobal.com/residence-investment/hong-kong",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Beijing",
      "latitude": 39.9385466,
      "longitude": 116.1172815,
      "country": "China",
      "HNWIGrowth": 70,
      "millionaires": 128200,
      "centiMillionaires": 354,
      "billionaires": 43,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Shanghai",
      "latitude": 31.2240453,
      "longitude": 121.196571,
      "country": "China",
      "HNWIGrowth": 72,
      "millionaires": 127200,
      "centiMillionaires": 332,
      "billionaires": 40,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": true,
      "topByRegion": true
    },
    {
      "city": "Sydney",
      "latitude": -33.8479271,
      "longitude": 150.6517948,
      "country": "Australia",
      "HNWIGrowth": 35,
      "millionaires": 126900,
      "centiMillionaires": 184,
      "billionaires": 15,
      "region": "Australasia",
      "linkText": "Apply for residence by investment in Australia here",
      "link": "https://www.henleyglobal.com/residence-investment/australia",
      "top10": true,
      "topByRegion": false
    },
    {
      "city": "Chicago",
      "latitude": 41.8336479,
      "longitude": -87.872046,
      "country": "USA",
      "HNWIGrowth": 24,
      "millionaires": 124000,
      "centiMillionaires": 295,
      "billionaires": 24,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Toronto",
      "latitude": 43.7181557,
      "longitude": -79.5181399,
      "country": "Canada",
      "HNWIGrowth": 29,
      "millionaires": 105200,
      "centiMillionaires": 193,
      "billionaires": 18,
      "region": "North America",
      "linkText": "Apply for residence by investment in Canada here",
      "link": "https://www.henleyglobal.com/residence-investment/canada",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Frankfurt",
      "latitude": 50.1211277,
      "longitude": 8.4964827,
      "country": "Germany",
      "HNWIGrowth": 20,
      "millionaires": 102200,
      "centiMillionaires": 170,
      "billionaires": 16,
      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Zurich",
      "latitude": 47.3774204,
      "longitude": 8.4666962,
      "country": "Switzerland",
      "HNWIGrowth": 35,
      "millionaires": 99300,
      "centiMillionaires": 250,
      "billionaires": 12,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Switzerland here",
      "link": "https://www.henleyglobal.com/residence-investment/switzerland",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Houston",
      "latitude": 29.8168824,
      "longitude": -95.6814729,
      "country": "USA",
      "HNWIGrowth": 65,
      "millionaires": 98500,
      "centiMillionaires": 280,
      "billionaires": 20,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Seoul",
      "latitude": 37.5645285,
      "longitude": 126.6870632,
      "country": "South Korea",
      "HNWIGrowth": 30,
      "millionaires": 97000,
      "centiMillionaires": 229,
      "billionaires": 24,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Melbourne",
      "latitude": -37.9722342,
      "longitude": 144.7729571,
      "country": "Australia",
      "HNWIGrowth": 42,
      "millionaires": 96000,
      "centiMillionaires": 123,
      "billionaires": 10,
      "region": "Australasia",
      "linkText": "Apply for residence by investment in Australia here",
      "link": "https://www.henleyglobal.com/residence-investment/australia",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Paris",
      "latitude": 48.8588336,
      "longitude": 2.2769958,
      "country": "France",
      "HNWIGrowth": -3,
      "millionaires": 93000,
      "centiMillionaires": 126,
      "billionaires": 16,
      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Geneva",
      "latitude": 46.2048287,
      "longitude": 6.1255293,
      "country": "Switzerland",
      "HNWIGrowth": 40,
      "millionaires": 85800,
      "centiMillionaires": 305,
      "billionaires": 15,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Switzerland here",
      "link": "https://www.henleyglobal.com/residence-investment/switzerland",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Dubai",
      "latitude": 25.0759567,
      "longitude": 55.0874044,
      "country": "UAE",
      "HNWIGrowth": 62,
      "millionaires": 68400,
      "centiMillionaires": 206,
      "billionaires": 15,
      "region": "Middle East",
      "linkText": "Apply for residence by investment in the UAE here",
      "link": "https://www.henleyglobal.com/residence-investment/united-arab-emirates",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Mumbai",
      "latitude": 19.0821978,
      "longitude": 72.7411023,
      "country": "India",
      "HNWIGrowth": 65,
      "millionaires": 59400,
      "centiMillionaires": 238,
      "billionaires": 29,
      "region": "South Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Rome",
      "latitude": 41.909986,
      "longitude": 12.3959159,
      "country": "Italy",
      "HNWIGrowth": -7,
      "millionaires": 56500,
      "centiMillionaires": 95,
      "billionaires": 11,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Italy here",
      "link": "https://www.henleyglobal.com/residence-investment/italy",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Seattle",
      "latitude": 47.6129432,
      "longitude": -122.4821459,
      "country": "USA",
      "HNWIGrowth": 68,
      "millionaires": 50500,
      "centiMillionaires": 121,
      "billionaires": 10,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Shenzhen",
      "latitude": 22.5550996,
      "longitude": 113.9137951,
      "country": "China",
      "HNWIGrowth": 98,
      "millionaires": 45700,
      "centiMillionaires": 140,
      "billionaires": 20,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Osaka",
      "latitude": 34.6775781,
      "longitude": 135.4159977,
      "country": "Japan",
      "HNWIGrowth": -2,
      "millionaires": 44900,
      "centiMillionaires": 72,
      "billionaires": 5,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Boston",
      "latitude": 42.3143286,
      "longitude": -71.0403234,
      "country": "USA",
      "HNWIGrowth": 50,
      "millionaires": 41700,
      "centiMillionaires": 104,
      "billionaires": 8,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Kyoto",
      "latitude": 35.0981156,
      "longitude": 135.5787867,
      "country": "Japan",
      "HNWIGrowth": 5,
      "millionaires": 40400,
      "centiMillionaires": 26,
      "billionaires": 2,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Miami",
      "latitude": 25.7823907,
      "longitude": -80.2994982,
      "country": "USA",
      "HNWIGrowth": 75,
      "millionaires": 38000,
      "centiMillionaires": 160,
      "billionaires": 12,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Vancouver",
      "latitude": 49.2577143,
      "longitude": -123.1939432,
      "country": "Canada",
      "HNWIGrowth": 44,
      "millionaires": 37300,
      "centiMillionaires": 67,
      "billionaires": 6,
      "region": "North America",
      "linkText": "Apply for residence by investment in Canada here",
      "link": "https://www.henleyglobal.com/residence-investment/canada",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Tel Aviv",
      "latitude": 32.0879267,
      "longitude": 34.7622266,
      "country": "Israel",
      "HNWIGrowth": 51,
      "millionaires": 35600,
      "centiMillionaires": 90,
      "billionaires": 11,
      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Moscow",
      "latitude": 55.5807482,
      "longitude": 36.8251525,
      "country": "Russian Federation",
      "HNWIGrowth": -44,
      "millionaires": 35200,
      "centiMillionaires": 250,
      "billionaires": 28,
      "region": "CIS",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Perth",
      "latitude": -32.0397559,
      "longitude": 115.681355,
      "country": "Australia",
      "HNWIGrowth": 32,
      "millionaires": 33900,
      "centiMillionaires": 53,
      "billionaires": 5,
      "region": "Australasia",
      "linkText": "Apply for residence by investment in Australia here",
      "link": "https://www.henleyglobal.com/residence-investment/australia",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Brisbane",
      "latitude": -27.3818631,
      "longitude": 152.7130142,
      "country": "Australia",
      "HNWIGrowth": 37,
      "millionaires": 31900,
      "centiMillionaires": 45,
      "billionaires": 4,
      "region": "Australasia",
      "linkText": "Apply for residence by investment in Australia here",
      "link": "https://www.henleyglobal.com/residence-investment/australia",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Austin",
      "latitude": 30.3074476,
      "longitude": -98.0428242,
      "country": "USA",
      "HNWIGrowth": 102,
      "millionaires": 30500,
      "centiMillionaires": 86,
      "billionaires": 9,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Hangzhou",
      "latitude": 30.261316,
      "longitude": 120.0318071,
      "country": "China",
      "HNWIGrowth": 105,
      "millionaires": 30400,
      "centiMillionaires": 98,
      "billionaires": 12,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Delhi",
      "latitude": 28.6440116,
      "longitude": 76.953148,
      "country": "India",
      "HNWIGrowth": 70,
      "millionaires": 30200,
      "centiMillionaires": 121,
      "billionaires": 16,
      "region": "South Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Madrid",
      "latitude": 40.4378698,
      "longitude": -3.8196188,
      "country": "Spain",
      "HNWIGrowth": -9,
      "millionaires": 29000,
      "centiMillionaires": 61,
      "billionaires": 6,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Spain here",
      "link": "https://www.henleyglobal.com/residence-investment/spain",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Auckland",
      "latitude": -36.8597287,
      "longitude": 174.5660385,
      "country": "New Zealand",
      "HNWIGrowth": 43,
      "millionaires": 24500,
      "centiMillionaires": 40,
      "billionaires": 2,
      "region": "Australasia",
      "linkText": "Apply for residence by investment in New Zealand here",
      "link": "https://www.henleyglobal.com/residence-investment/new-zealand",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Abu Dhabi",
      "latitude": 24.3867662,
      "longitude": 54.4185369,
      "country": "UAE",
      "HNWIGrowth": 70,
      "millionaires": 24200,
      "centiMillionaires": 68,
      "billionaires": 4,
      "region": "Middle East",
      "linkText": "Apply for residence by investment in the UAE here",
      "link": "https://www.henleyglobal.com/residence-investment/united-arab-emirates",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Manchester",
      "latitude": 53.472225,
      "longitude": -2.293502,
      "country": "UK",
      "HNWIGrowth": 5,
      "millionaires": 24200,
      "centiMillionaires": 73,
      "billionaires": 8,
      "region": "Europe",
      "linkText": "Apply for residence by investment in the UK here",
      "link": "https://www.henleyglobal.com/residence-investment/united-kingdom",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Nice",
      "latitude": 43.7031728,
      "longitude": 7.1810542,
      "country": "France",
      "HNWIGrowth": 7,
      "millionaires": 23900,
      "centiMillionaires": 60,
      "billionaires": 6,
      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Guangzhou",
      "latitude": 23.1253503,
      "longitude": 112.9476607,
      "country": "China",
      "HNWIGrowth": 86,
      "millionaires": 23500,
      "centiMillionaires": 64,
      "billionaires": 8,
      "region": "Asia Pacific",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Athens",
      "latitude": 37.990832,
      "longitude": 23.70332,
      "country": "Greece",
      "HNWIGrowth": -3,
      "millionaires": 23100,
      "centiMillionaires": 38,
      "billionaires": 2,

      "region": "Europe",
      "linkText": "Apply for residence by investment in Greece here",
      "link": "https://www.henleyglobal.com/residence-investment/greece",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Doha",
      "latitude": 25.2839926,
      "longitude": 51.4419569,
      "country": "Qatar",
      "HNWIGrowth": -6,
      "millionaires": 21500,
      "centiMillionaires": 48,
      "billionaires": 3,
      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Lisbon",
      "latitude": 38.7436214,
      "longitude": -9.1952226,
      "country": "Portugal",
      "HNWIGrowth": 25,
      "millionaires": 20800,
      "centiMillionaires": 35,
      "billionaires": 3,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Portugal here",
      "link": "https://www.henleyglobal.com/residence-investment/portugal",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Dublin",
      "latitude": 53.3242381,
      "longitude": -6.3857848,
      "country": "Ireland",
      "HNWIGrowth": 52,
      "millionaires": 18400,
      "centiMillionaires": 40,
      "billionaires": 5,
      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Riyadh",
      "latitude": 24.7249316,
      "longitude": 46.5423458,
      "country": "Saudi Arabia",
      "HNWIGrowth": 9,
      "millionaires": 18100,
      "centiMillionaires": 63,
      "billionaires": 8,
      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Montreal",
      "latitude": 45.5590971,
      "longitude": -73.851955,
      "country": "Canada",
      "HNWIGrowth": 21,
      "millionaires": 17900,
      "centiMillionaires": 26,
      "billionaires": 2,
      "region": "North America",
      "linkText": "Apply for residence by investment in Canada here",
      "link": "https://www.henleyglobal.com/residence-investment/canada",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Monaco",
      "latitude": 43.7378511,
      "longitude": 7.4170977,
      "country": "Monaco",
      "HNWIGrowth": 50,
      "millionaires": 17600,
      "centiMillionaires": 165,
      "billionaires": 20,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Monaco here",
      "link": "https://www.henleyglobal.com/residence-investment/monaco",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Las Vegas",
      "latitude": 36.1249185,
      "longitude": -115.3150826,
      "country": "USA",
      "HNWIGrowth": 55,
      "millionaires": 16800,
      "centiMillionaires": 45,
      "billionaires": 6,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Istanbul",
      "latitude": 41.0052367,
      "longitude": 28.8720973,
      "country": "Türkiye",
      "HNWIGrowth": -35,
      "millionaires": 16300,
      "centiMillionaires": 62,
      "billionaires": 10,
      "region": "Europe",
      "linkText": "Apply for citizenship by investment in Türkiye here",
      "link": "https://www.henleyglobal.com/citizenship-investment/turkey",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Warsaw",
      "latitude": 52.232855,
      "longitude": 20.9211133,
      "country": "Poland",
      "HNWIGrowth": 54,
      "millionaires": 15100,
      "centiMillionaires": 33,
      "billionaires": 3,
      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Jerusalem",
      "latitude": 31.7962994,
      "longitude": 35.1053193,
      "country": "Israel",
      "HNWIGrowth": 37,
      "millionaires": 15100,
      "centiMillionaires": 48,
      "billionaires": 5,
      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "San Diego",
      "latitude": 32.8242404,
      "longitude": -117.3891588,
      "country": "USA",
      "HNWIGrowth": 58,
      "millionaires": 14700,
      "centiMillionaires": 70,
      "billionaires": 4,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Calgary",
      "latitude": 51.0275396,
      "longitude": -114.227916,
      "country": "Canada",
      "HNWIGrowth": 48,
      "millionaires": 14700,
      "centiMillionaires": 21,
      "billionaires": 2,
      "region": "North America",
      "linkText": "Apply for residence by investment in Canada here",
      "link": "https://www.henleyglobal.com/residence-investment/canada",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Johannesburg",
      "latitude": -26.1709473,
      "longitude": 27.9963496,
      "country": "South Africa",
      "HNWIGrowth": -40,
      "millionaires": 14600,
      "centiMillionaires": 30,
      "billionaires": 2,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true,
    },
    {
      "city": "Scottsdale",
      "latitude": 33.6738791,
      "longitude": -112.1455333,
      "country": "USA",
      "HNWIGrowth": 88,
      "millionaires": 13900,
      "centiMillionaires": 60,
      "billionaires": 5,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Barcelona",
      "latitude": 41.3925788,
      "longitude": 1.9966664,
      "country": "Spain",
      "HNWIGrowth": -7,
      "millionaires": 13300,
      "centiMillionaires": 26,
      "billionaires": 3,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Spain here",
      "link": "https://www.henleyglobal.com/residence-investment/spain",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Milan",
      "latitude": 45.4627124,
      "longitude": 9.1076929,
      "country": "Italy",
      "HNWIGrowth": -10,
      "millionaires": 12600,
      "centiMillionaires": 20,
      "billionaires": 4,
      "region": "Europe",
      "linkText": "Apply for residence by investment in Italy here",
      "link": "https://www.henleyglobal.com/residence-investment/italy",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Bengaluru",
      "latitude": 12.9538403,
      "longitude": 77.3438488,
      "country": "India",
      "HNWIGrowth": 88,
      "millionaires": 12600,
      "centiMillionaires": 50,
      "billionaires": 8,
      "region": "South Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false    
    },
    {
      "city": "Edinburgh",
      "latitude": 55.9411885,
      "longitude": -3.2753778,
      "country": "UK",
      "HNWIGrowth": -12,
      "millionaires": 12400,
      "centiMillionaires": 48,
      "billionaires": 5,
      "region": "Europe",
      "linkText": "Apply for residence by investment in the UK here",
      "link": "https://www.henleyglobal.com/residence-investment/united-kingdom",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Santa Barbara & Montecito",
      "latitude": 34.3985821,
      "longitude": -119.7848749,
      "country": "USA",
      "HNWIGrowth": 65,
      "millionaires": 12300,
      "centiMillionaires": 82,
      "billionaires": 6,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Kolkata",
      "latitude": 22.5354122,
      "longitude": 88.2773129,
      "country": "India",
      "HNWIGrowth": 60,
      "millionaires": 12100,
      "centiMillionaires": 49,
      "billionaires": 7,
      "region": "South Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Greenwich & Darien",
      "latitude": 41.0450034,
      "longitude": -73.6242558,
      "country": "USA",
      "HNWIGrowth": 72,
      "millionaires": 11900,
      "centiMillionaires": 112,
      "billionaires": 8,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Hyderabad",
      "latitude": 17.4122998,
      "longitude": 78.2679616,
      "country": "India",
      "HNWIGrowth": 78,
      "millionaires": 11100,
      "centiMillionaires": 40,
      "billionaires": 5,
      "region": "South Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "West Palm Beach",
      "latitude": 26.7419207,
      "longitude": -80.1990797,
      "country": "USA",
      "HNWIGrowth": 90,
      "millionaires": 9400,
      "centiMillionaires": 64,
      "billionaires": 6,
      "region": "North America",
      "linkText": "Apply for residence by investment in the USA here",
      "link": "https://www.henleyglobal.com/residence-investment/united-states",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Ho Chi Minh City",
      "latitude": 10.7546664,
      "longitude": 106.4150416,
      "country": "Vietnam",
      "HNWIGrowth": 82,
      "millionaires": 7700,
      "centiMillionaires": 15,
      "billionaires": 3,
      "region": "Southeast Asia",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Florence",
      "latitude": 43.7799528,
      "longitude": 11.2059486,
      "country": "Italy",
      "HNWIGrowth": 8,
      "millionaires": 7500,
      "centiMillionaires": 16,
      "billionaires": 3,

      "region": "Europe",
      "linkText": "Apply for residence by investment in Italy here",
      "link": "https://www.henleyglobal.com/residence-investment/italy",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Cairo",
      "latitude": 30.0594838,
      "longitude": 31.223445,
      "country": "Egypt",
      "HNWIGrowth": -25,
      "millionaires": 7400,
      "centiMillionaires": 27,
      "billionaires": 5,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Cape Town",
      "latitude": -33.9152208,
      "longitude": 18.3758795,
      "country": "South Africa",
      "HNWIGrowth": 10,
      "millionaires": 7200,
      "centiMillionaires": 26,
      "billionaires": 1,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "St. Petersburg",
      "latitude": 59.940117,
      "longitude": 29.8145045,
      "country": "Russian Federation",
      "HNWIGrowth": -38,
      "millionaires": 6900,
      "centiMillionaires": 55,
      "billionaires": 7,
      "region": "CIS",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Lagos",
      "latitude": 6.5480503,
      "longitude": 3.2139196,
      "country": "Nigeria",
      "HNWIGrowth": -30,
      "millionaires": 5400,
      "centiMillionaires": 16,
      "billionaires": 3,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Budapest",
      "latitude": 47.4811282,
      "longitude": 18.9902216,
      "country": "Hungary",
      "HNWIGrowth": 32,
      "millionaires": 5300,
      "centiMillionaires": 12,
      "billionaires": "",

      "region": "Europe",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Nairobi",
      "latitude": -1.303208,
      "longitude": 36.7773568,
      "country": "Kenya",
      "HNWIGrowth": 30,
      "millionaires": 4700,
      "centiMillionaires": 11,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": true
    },
    {
      "city": "Netanya",
      "latitude": 32.3047236,
      "longitude": 34.8253686,
      "country": "Israel",
      "HNWIGrowth": 56,
      "millionaires": 4300,
      "centiMillionaires": 20,
      "billionaires": 2,

      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Herzliya",
      "latitude": 32.1731032,
      "longitude": 34.810494,
      "country": "Israel",
      "HNWIGrowth": 65,
      "millionaires": 3900,
      "centiMillionaires": 14,
      "billionaires": 2,
      "region": "Middle East",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Sharjah",
      "latitude": 25.3196604,
      "longitude": 55.4753992,
      "country": "UAE",
      "HNWIGrowth": 84,
      "millionaires": 3800,
      "centiMillionaires": 8,
      "billionaires": "",
      "region": "Middle East",
      "linkText": "Apply for residence by investment in the UAE here",
      "link": "https://www.henleyglobal.com/residence-investment/united-arab-emirates",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Durban",
      "latitude": -29.868455,
      "longitude": 30.9209122,
      "country": "South Africa",
      "HNWIGrowth": -6,
      "millionaires": 3600,
      "centiMillionaires": 10,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Cape Winelands",
      "latitude": -33.1455995,
      "longitude": 18.7102663,
      "country": "South Africa",
      "HNWIGrowth": 18,
      "millionaires": 3400,
      "centiMillionaires": 15,
      "billionaires": 2,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Garden Route",
      "latitude": -33.8756596,
      "longitude": 21.5428078,
      "country": "South Africa",
      "HNWIGrowth": 22,
      "millionaires": 3000,
      "centiMillionaires": 5,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Casablanca",
      "latitude": 33.5722678,
      "longitude": -7.6570321,
      "country": "Morocco",
      "HNWIGrowth": 28,
      "millionaires": 2800,
      "centiMillionaires": 14,
      "billionaires": 2,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Pretoria",
      "latitude": -25.7585829,
      "longitude": 28.057867,
      "country": "South Africa",
      "HNWIGrowth": -35,
      "millionaires": 2400,
      "centiMillionaires": 2,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Accra",
      "latitude": 5.5912045,
      "longitude": -0.2497694,
      "country": "Ghana",
      "HNWIGrowth": 24,
      "millionaires": 2000,
      "centiMillionaires": 4,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Luanda",
      "latitude": -8.8535258,
      "longitude": 13.2140645,
      "country": "Angola",
      "HNWIGrowth": -28,
      "millionaires": 1800,
      "centiMillionaires": 3,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Dar Es Salaam",
      "latitude": -6.769507,
      "longitude": 38.9671988,
      "country": "Tanzania",
      "HNWIGrowth": 20,
      "millionaires": 1400,
      "centiMillionaires": 4,
      "billionaires": 1,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Whale Coast",
      "latitude": -34.4169,
      "longitude": 19.1818228,
      "country": "South Africa",
      "HNWIGrowth": 25,
      "millionaires": 1100,
      "centiMillionaires": 5,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Windhoek",
      "latitude": -22.5637525,
      "longitude": 17.0272066,
      "country": "Namibia",
      "HNWIGrowth": 16,
      "millionaires": 1100,
      "centiMillionaires": 2,
      "billionaires": "",
      "region": "Africa",
      "linkText": "Apply for residence by investment in Namibia here",
      "link": "https://www.henleyglobal.com/residence-investment/namibia",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Marrakech",
      "latitude": 31.6346023,
      "longitude": -8.0778928,
      "country": "Morocco",
      "HNWIGrowth": 55,
      "millionaires": 900,
      "centiMillionaires": 8,
      "billionaires": 2,
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Addis Ababa",
      "latitude": 8.9631703,
      "longitude": 38.7081048,
      "country": "Ethiopia",
      "HNWIGrowth": 23,
      "millionaires": 800,
      "centiMillionaires": 2,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Kigali",
      "latitude": -1.9297692,
      "longitude": 30.0572044,
      "country": "Rwanda",
      "HNWIGrowth": 72,
      "millionaires": 800,
      "centiMillionaires": 2,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Maputo",
      "latitude": -25.8962418,
      "longitude": 32.5406438,
      "country": "Mozambique",
      "HNWIGrowth": 18,
      "millionaires": 800,
      "centiMillionaires": 1,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Mombasa",
      "latitude": -4.0351857,
      "longitude": 39.5962232,
      "country": "Kenya",
      "HNWIGrowth": 35,
      "millionaires": 700,
      "centiMillionaires": 2,
      "billionaires": "",

      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Tangier",
      "latitude": 35.7632692,
      "longitude": -5.8694892,
      "country": "Morocco",
      "HNWIGrowth": 33,
      "millionaires": 700,
      "centiMillionaires": 3,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Lusaka",
      "latitude": -15.4168189,
      "longitude": 28.2737131,
      "country": "Zambia",
      "HNWIGrowth": 22,
      "millionaires": 600,
      "centiMillionaires": 2,
      "billionaires": "",
      "region": "Africa",
      "linkText": "",
      "link": "",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Swakopmund",
      "latitude": -22.6377445,
      "longitude": 14.5625598,
      "country": "Namibia",
      "HNWIGrowth": 25,
      "millionaires": 300,
      "centiMillionaires": 1,
      "billionaires": "",
      "region": "Africa",
      "linkText": "Apply for residence by investment in Namibia here",
      "link": "https://www.henleyglobal.com/residence-investment/namibia",
      "top10": false,
      "topByRegion": false
    },
    {
      "city": "Walvis Bay",
      "latitude": "-22.9540119,14",
      "longitude": 14.4945188,
      "country": "Namibia",
      "HNWIGrowth": 22,
      "millionaires": 300,
      "centiMillionaires": "",
      "billionaires": "",
      "region": "Africa",
      "linkText": "Apply for residence by investment in Namibia here",
      "link": "https://www.henleyglobal.com/residence-investment/namibia",
      "top10": false,
      "topByRegion": false
    }
];

export {countryOverview};